// extracted by mini-css-extract-plugin
export default {"tagList":"TagsInput_tagList__o-CWh","tagListWrapper":"TagsInput_tagListWrapper__gfr49"};